<template>
  <div class="toolbar-container">
    <div class="toolbar">
      <!-- <div class="buttonContainer">
        <button class="hoverButton">
          <i id="mic-icon" class="fas fa-microphone fa-xs">+ Invite</i>
        </button>
      </div> -->
      <!-- <RoomBottomLeftBar :sessionID="sessionID" /> -->
      <div class="media-buttons" v-if="localParticipant" :style="transparentColor">
        <div class="tooltip_container" v-if="!isMobile">
          <div :class="userMediaSettings.screenBeingShared ? 'screen-button-green' : 'screen-button'" @click="toggleMedia(2)">
            <IconBase icon-name="screenshare" :iconColor="userMediaSettings.screenBeingShared ? getColor('video') : getSecondColor('video')" viewBox="0 0 469.333 469.333" width="100%" height="100%"
              ><IconScreenshare
            /></IconBase>
          </div>
          <div class="tooltip tooltip--top tooltip--middle">
            <span class="tooltip_tip">{{ userMediaSettings.screenBeingShared ? "Stop screenshare" : "Share screen" }}</span>
            <span class="tooltip_shortcut">ALT+Z</span>
          </div>
        </div>

        <div class="tooltip_container">
          <div :class="userMediaSettings.cameraOn ? 'video-call-button' : 'video-call-button-red'" @click="toggleMedia(0)">
            <IconBase icon-name="video" viewBox="0 0 50 50" width="100%" height="100%" :iconColor="userMediaSettings.cameraOn ? getSecondColor('video') : getColor('video')"><IconVideo /></IconBase>
          </div>
          <div class="tooltip tooltip--top tooltip--middle">
            <span class="tooltip_tip">{{ userMediaSettings.cameraOn ? "Turn camera off" : "Turn camera on" }}</span>
            <span class="tooltip_shortcut">ALT+C</span>
          </div>
        </div>
        <div class="tooltip_container">
          <div :class="userMediaSettings.microphoneOn ? 'audio-button' : 'audio-button-red'" @click="toggleMedia(1)">
            <IconBase
              v-if="userMediaSettings.microphoneOn"
              icon-name="microphone"
              :iconColor="userMediaSettings.microphoneOn ? getSecondColor('video') : getColor('video')"
              viewBox="-96 0 448 448"
              width="100%"
              height="100%"
              strokeWidth="5px"
              ><IconMic
            /></IconBase>
            <IconBase
              v-else
              icon-name="microphone"
              :iconColor="userMediaSettings.microphoneOn ? getSecondColor('video') : getColor('video')"
              viewBox="-55 0 416 416.238"
              width="100%"
              height="100%"
              strokeWidth="5px"
              ><IconMicOff
            /></IconBase>
          </div>
          <div class="tooltip tooltip--top tooltip--middle">
            <span class="tooltip_tip">{{ userMediaSettings.microphoneOn ? "Turn mic off" : "Turn mic on" }}</span>
            <span class="tooltip_shortcut">M</span>
          </div>
        </div>
        <div class="tooltip_container" v-if="browserSupportsPIP && remoteParticipantData && !isMobile">
          <div :class="pipClasses" @click="toggleMedia(3)">
            <IconBase icon-name="screenshare" :iconColor="userMediaSettings.pictureInPictureEnabled ? getColor('video') : getSecondColor('video')" viewBox="0 0 64 64" width="100%" height="100%"
              ><IconPictureInPicture
            /></IconBase>
          </div>
          <div class="tooltip tooltip--top tooltip--middle">
            <span class="tooltip_tip">{{ pipTooltipText }}</span>
            <span class="tooltip_shortcut" v-if="userMediaSettings.cameraOn && partnerVideo">ALT+P</span>
          </div>
        </div>

        <div class="tooltip_container" v-if="brb.enabled">
          <div class="toggle-button" :class="getBRBClasses" @click="toggleOwnState('brb')">
            <div class="brb" v-if="!brb.supportState || brb.supportState == ''">brb</div>
            <div class="brb" v-else>
              <span class="supportEmoji">{{ emojis[brb.supportState] }}</span
              >brb
            </div>
          </div>
          <div class="tooltip tooltip--top tooltip--middle">
            <span class="tooltip_tip">{{ brb.value ? "Stop BRB" : "Be Right Back" }}</span>
            <span class="tooltip_shortcut">B</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import isMobile from "ismobilejs";
import videoIcon from "../../../assets/images/video-darkblue.png";
import videoIconWhite from "../../../assets/images/video-call-white.png";
import audioIcon from "../../../assets/images/microphone-blue.png";
import audioIconWhite from "../../../assets/images/microphone-white.png";
import screenIcon from "../../../assets/images/screen-darkblue.png";
import screenIconWhite from "../../../assets/images/screen-white.png";
import pipIcon from "../../../assets/images/pip.png";
import pipIconWhite from "../../../assets/images/pip-white.png";
import hangUpIcon from "../../../assets/images/hangup.png";

import IconBase from "../../../components/IconBase";
import IconVideo from "../../../components/SVG/IconVideo";
import IconMic from "../../../components/SVG/IconMic";
import IconMicOff from "../../../components/SVG/IconMicOff";
import IconScreenshare from "../../../components/SVG/IconScreenshare";
import IconPictureInPicture from "../../../components/SVG/IconPictureInPicture";

// import RoomBottomLeftBar from "./RoomBottomLeftBar";

import { initPictureInPictureListening } from "../Session/SessionHelpers/media";

import { toggleOwnState } from "../Session/SessionHelpers/session";

import { transparentColor } from "../Session/SessionHelpers/colors";

export default {
  name: "RoomBottomBar",
  data() {
    return {
      errors: false,
      videoIcon: videoIcon,
      videoIconWhite: videoIconWhite,
      audioIcon: audioIcon,
      audioIconWhite: audioIconWhite,
      screenIcon: screenIcon,
      screenIconWhite: screenIconWhite,
      pipIcon: pipIcon,
      pipIconWhite: pipIconWhite,
      hangUpIcon: hangUpIcon,

      emojis: {
        coffee: "☕",
        tea: "🍵",
        water: "🚰",
        restroom: "🚾",
        dino: "🦕",
        unicorn: "🦄",
        kitty: "🐈",
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      sessionID: (state) => state.session.sessionID,
      userMediaSettings: (state) => state.mediastates.userMediaSettings,
      localParticipant: (state) => state.room.localParticipantData,
      remoteParticipantData: (state) => state.room.remoteParticipantData,
      partnerVideo: (state) => state.room.partnerVideo,
      brb: (state) => state.mediastates.ownState.brb,
    }),
    isMobile() {
      return isMobile().phone ? true : false;
    },
    getMicColor() {
      return "#2d2d2d";
    },
    getCoreColor() {
      return "#2d2d2d";
    },
    getMicSecondColor() {
      return "#2d2d2d";
    },
    browserSupportsPIP() {
      return "pictureInPictureEnabled" in document;
    },
    getBRBClasses() {
      let classes = "";
      if (this.brb.value) {
        classes = "toggle-purple";
      }
      if (this.brb.supportState) {
        classes = classes + " " + "supportState";
      }
      if (this.brb.supportState == "dino") {
        classes = classes + " " + "dino-color";
      }
      return classes;
    },
    transparentColor() {
      return transparentColor();
    },

    pipClasses() {
      if (!this.userMediaSettings.cameraOn || !this.partnerVideo) {
        return "pip-button pip-disabled";
      }
      return this.userMediaSettings.pictureInPictureEnabled ? "pip-button-green" : "pip-button";
    },
    pipTooltipText() {
      if (this.userMediaSettings.cameraOn && this.partnerVideo) {
        return this.userMediaSettings.pictureInPictureEnabled ? "Pop back video" : "Pop out video";
      } else if (this.userMediaSettings.cameraOn && !this.partnerVideo) {
        return "Disabled while partner's video is turned off";
      } else if (!this.userMediaSettings.cameraOn) {
        return "Disabled while your video is turned off";
      }
      return "";
    },
  },
  components: {
    IconBase,
    IconVideo,
    IconMic,
    IconMicOff,
    IconScreenshare,
    // RoomBottomLeftBar,
    IconPictureInPicture,
  },
  methods: {
    toggleMedia(type) {
      // 0 - video
      // 1 - audio
      // 2 - screenshare
      // 3 - picture-in-picture
      if (type === 3) {
        initPictureInPictureListening();
      }
      this.$emit("toggleMedia", type);
    },
    toggleShutRestart() {
      this.$emit("toggleShutRestart");
    },
    toggleToolbar(toolbarTool) {
      let data = {
        toolbarTool,
      };

      if (toolbarTool) {
        data.boolean = !this[toolbarTool];
        this.$store.dispatch("toolbar/toggleToolbar", data);
      }
    },
    getColor(icon) {
      console.log("icon", icon);
      return "#fff";
    },
    getSecondColor(icon) {
      console.log("icon", icon);
      return "#2d2d2d";
    },

    toggleOwnState(state) {
      toggleOwnState(state);
    },
  },
};
</script>
<style scoped>
/* Only for debugging */
* {
  box-sizing: border-box;
}

.sidebar-inner {
  box-sizing: border-box;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.toolbar-container {
  height: 48px;
  width: calc(100% - 50px);
  /* border: 2px solid red; */
  position: absolute;
  bottom: 0;
  padding: 30px 15px;
  box-sizing: unset !important;
  z-index: 51;
}

.toolbar {
  display: flex;
  flex-direction: row;
  position: relative;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  box-sizing: unset !important;
}

.video-control-buttons {
  display: flex;
  flex-direction: row;
}
.leave {
  position: absolute;
  right: 5px;
}

.media-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ffffffde;
  border-radius: 360px;
  padding: 2px 14px;
  background-color: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(5px);
  box-shadow: 0 1px 4px 0 hsl(0deg 0% 69% / 40%);
}
.video-call-button,
.audio-button,
.settings-button,
.screen-button,
.pip-button,
.leave-button,
.toggle-button {
  /* border: 1px solid #ececec; */
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  width: 46px;
  padding: 11px;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  border-radius: 360px;
}

.settings-button {
  background-color: #f3f2f2;
}
.video-call-button:hover,
.audio-button:hover,
.screen-button:hover,
.pip-button:hover,
.leave-button:hover,
.toggle-button:hover {
  background-color: #f3f2f2;
}
.video-call-icon,
.video-call-icon-white,
.audio-icon,
.audio-icon-white,
.settings-icon,
.screen-icon,
.screen-icon-white,
.pip-icon,
.pip-icon-white,
.leave-icon {
  width: 28px;
  height: 28px;
  margin: auto;
}
.video-call-button-red,
.audio-button-red {
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  width: 46px;
  padding: 10px;
  cursor: pointer;
  background-color: #d12b54;
  position: relative;
  box-sizing: border-box;
  border-radius: 360px;
}
.video-call-button-red:hover,
.audio-button-red:hover {
  background-color: #a72143;
}

.screen-button-green,
.pip-button-green {
  border-radius: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 46px;
  width: 46px;
  padding: 10px;
  cursor: pointer;
  background-color: #15c27a;
  position: relative;
  box-sizing: border-box;
}
.screen-button-green:hover,
.pip-button-green:hover {
  background-color: #2ca271;
}

.pip-disabled {
  cursor: not-allowed;
  filter: opacity(0.5);
}

.toggle-purple {
  background-color: #5600ff;
  color: white !important;
}
.toggle-purple:hover {
  background-color: #4c03dc;
}

.brb {
  font-size: 15px;
  font-weight: 700;
  font-family: "Nunito";
  display: flex;
  justify-content: center;
  align-items: center;
}

.supportState {
  width: 60px !important;
}

.supportEmoji {
  font-size: 14px;
  margin-right: 2px;
}

*,
::before,
::after {
  box-sizing: border-box;
}
::before,
::after {
  text-decoration: inherit;
  vertical-align: inherit;
}
svg {
  vertical-align: middle;
}
svg:not([fill]) {
  fill: currentColor;
}
svg:not(:root) {
  overflow: hidden;
}
::-webkit-input-placeholder {
  color: inherit;
  opacity: 0.54;
}
::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
:-moz-focusring {
  outline: 1px dotted ButtonText;
}
/*! CSS Used from: Embedded */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
/*! CSS Used from: Embedded */
*,
::before,
::after {
  box-sizing: border-box;
}
::before,
::after {
  text-decoration: inherit;
  vertical-align: inherit;
}
hr {
  height: 0;
  overflow: visible;
}
svg {
  vertical-align: middle;
}
svg:not([fill]) {
  fill: currentColor;
}
svg:not(:root) {
  overflow: hidden;
}

select {
  margin: 0;
}
select {
  text-transform: none;
}
::-webkit-input-placeholder {
  color: inherit;
  opacity: 0.54;
}
::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
:-moz-focusring {
  outline: 1px dotted ButtonText;
}
label,
select {
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}
/*! CSS Used from: Embedded */
.knpf {
  --knpf-color: var(--knpf-color-hue), var(--knpf-color-saturation), var(--knpf-color-luminosity);
  --knpf-hover-color: var(--knpf-color-hue), var(--knpf-color-saturation), calc(var(--knpf-color-luminosity) - 10%);
  --knpf-active-color: var(--knpf-color-hue), var(--knpf-color-saturation), calc(var(--knpf-color-luminosity) - 15%);
  --knpf-background-color: hsl(var(--knpf-color));
  --knpf-border-color: transparent;
  --knpf-text-color: white;
  --knpf-hover-background-color: hsl(var(--knpf-hover-color));
  --knpf-hover-border-color: transparent;
  --knpf-hover-text-color: white;
  --knpf-active-background-color: hsl(var(--knpf-active-color));
  --knpf-active-border-color: transparent;
  --knpf-active-text-color: white;
  --knpf-vertical-padding: var(--knpf-padding);
  --knpf-horizontal-padding: calc(var(--knpf-padding) * 2);
  align-items: center;
  background-color: var(--knpf-background-color);
  border: var(--knpf-border-width) var(--knpf-border-style) var(--knpf-border-color);
  border-radius: var(--knpf-border-radius);
  box-sizing: border-box;
  color: var(--knpf-text-color);
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  font-family: var(--knpf-font-family);
  font-size: var(--knpf-font-size);
  font-weight: var(--knpf-font-weight);
  line-height: var(--knpf-line-height);
  justify-content: var(--knpf-justify-content);
  padding: var(--knpf-vertical-padding) var(--knpf-horizontal-padding);
  position: relative;
  text-decoration: none;
  text-transform: var(--knpf-text-transform);
  transition: var(--knpf-transition);
  white-space: nowrap;
}
.knpf:visited {
  color: var(--knpf-text-color);
}
.knpf:disabled {
  cursor: default;
  opacity: 0.4;
  pointer-events: none;
}
.knpf--small {
  --knpf-font-size: var(--knpf-font-size-small);
  --knpf-padding: var(--knpf-padding-small);
  --knpf-icon-size: var(--knpf-icon-size-small);
}
.knpf--large {
  --knpf-font-size: var(--knpf-font-size-large);
  --knpf-padding: var(--knpf-padding-large);
  --knpf-icon-size: var(--knpf-icon-size-large);
}
.knpf--flat {
  --knpf-background-color: transparent;
  --knpf-text-color: hsl(var(--knpf-color));
  --knpf-hover-background-color: hsla(var(--knpf-color), 0.15);
  --knpf-hover-text-color: hsl(var(--knpf-hover-color));
  --knpf-active-background-color: hsla(var(--knpf-color), 0.25);
  --knpf-active-text-color: hsl(var(--knpf-active-color));
}
.knpf--pale {
  --knpf-background-color: hsla(var(--knpf-color), 0.1);
  --knpf-text-color: hsl(var(--knpf-color));
  --knpf-hover-background-color: hsla(var(--knpf-color), 0.2);
  --knpf-hover-text-color: hsl(var(--knpf-hover-color));
  --knpf-active-background-color: hsla(var(--knpf-color), 0.3);
  --knpf-active-text-color: hsl(var(--knpf-active-color));
}
.knpf--outline {
  --knpf-border-color: hsla(var(--knpf-color), 0.25);
  --knpf-hover-border-color: hsla(var(--knpf-color), 0.25);
  --knpf-active-border-color: hsla(var(--knpf-color), 0.25);
}
.knpf--even {
  --knpf-horizontal-padding: var(--knpf-padding);
}
.knpf--pill {
  --knpf-border-radius: 9999px;
}
.knpf--secondary {
  --knpf-color-hue: var(--knpf-secondary-color-hue);
  --knpf-color-saturation: var(--knpf-secondary-color-saturation);
  --knpf-color-luminosity: var(--knpf-secondary-color-luminosity);
}
.knpf_icon {
  align-items: center;
  color: inherit;
  display: inline-flex;
  fill: currentColor;
  flex-shrink: 0;
  font-size: var(--knpf-icon-size);
  height: var(--knpf-icon-size);
  justify-content: center;
  width: var(--knpf-icon-size);
}
.knpf_icon:first-child:not(:only-child) {
  margin-left: calc(var(--knpf-horizontal-padding) * -0.25);
  margin-right: calc(var(--knpf-horizontal-padding) * 0.5);
}
.knpf_group {
  border-radius: var(--knpf-border-radius);
  display: inline-flex;
  position: relative;
}
.knpf_group--spaced {
  --knpf-group-spacing: var(--knpf-padding);
}
.knpf_group:not(.knpf_group--vertical) > * + * {
  margin-left: var(--knpf-group-spacing);
}
/*! CSS Used from: Embedded */
.tooltip {
  background: #2d2d2d;
  display: var(--tooltip-display);
  border-radius: 4px;
  color: white;
  filter: var(--tooltip-filter, none);
  flex-direction: row;
  flex-shrink: 0;
  font-weight: normal;
  font-size: 12px;
  padding: 6px 12px;
  position: absolute;
  text-align: center;
  transform: translate(var(--translateX, 0), var(--translateY, 0));
  white-space: nowrap;
  z-index: 900;
}
.tooltip::before {
  background: #2d2d2d;
  display: block;
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  z-index: 1;
}
.tooltip--top {
  --translateY: calc(-100% - 8px);
  top: -4px;
}
.tooltip--top::before {
  bottom: 0;
  transform: rotate(45deg) translate(-50%, 50%);
  transform-origin: left bottom;
}
.tooltip--top.tooltip--middle {
  --translateX: -50%;
  left: 50%;
}
.tooltip--top.tooltip--middle::before {
  left: 50%;
}
.tooltip_container {
  --tooltip-display: none;
  display: inline-flex;
  position: relative;
  margin-right: 10px;
}
@media (hover: hover) {
  .tooltip_container:hover {
    --tooltip-display: flex;
  }
}
.tooltip_shortcut {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  color: #adb6d1;
  margin-left: 8px;
  padding: 1px 5px;
  text-transform: uppercase;
}
/*! CSS Used from: Embedded */
h3 {
  margin: 0;
}
select {
  font: inherit;
}
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
.pos-rel {
  position: relative;
}
.knpf {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.knpf--round {
  --knpf-border-radius: 8px;
}
.knpf_icon:not([fill]) {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
.knpf_group--spaced > * + * {
  margin-left: var(--knpf-group-spacing);
}
.Select {
  --select-padding: 12px;
  -webkit-appearance: none;
  background-color: white;
  background-repeat: no-repeat;
  background-position: calc(100% - 12px) center;
  border: 1px solid var(--grey3);
  border-radius: 8px;
  border-color: #adb6d1;
  color: #1e2f58;
  font-weight: normal;
  padding: var(--select-padding);
  padding-right: 36px;
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: stretch;
}
.Select--with-icon {
  padding-left: calc(var(--select-padding) + 32px);
}
.Select_Wrapper {
  position: relative;
}
.Select_Icon {
  height: 22px;
  left: 12px;
  margin-top: -11px;
  position: absolute;
  width: 22px;
  top: 50%;
}
.mute-message {
  text-align: left;
}
.mute-message_title {
  font-size: 16px;
  margin-bottom: 8px;
}
.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.py-16 {
  padding-bottom: 16px !important;
  padding-top: 16px !important;
}
hr {
  border-color: #e0e4f0;
  border-width: 0 0 1px 0;
  margin: 12px 0;
}
/*! CSS Used from: Embedded */
.VideoCallSettings[data-v-4b6636bc] {
  background: white;
  border: 1px solid #edeff5;
  border-radius: 4px;
  bottom: calc(100% + 6px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-size: 16px;
  padding: 16px;
  position: absolute;
  text-align: left;
  width: 380px;
  z-index: 400;
}
@media screen and (max-width: 991px) {
  .VideoCallSettings[data-v-4b6636bc] {
    transform: translateX(-50%);
    margin-left: 50%;
    z-index: 900;
  }
}
@media (max-width: 575px) {
  .VideoCallSettings[data-v-4b6636bc] {
    bottom: 16px;
    margin: 0;
    position: fixed;
    right: 16px;
    transform: none;
    width: calc(100vw - 32px);
  }
}
.VideoCallSettings_Label[data-v-4b6636bc] {
  align-items: flex-start;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}
.VideoCallSettings_Divider[data-v-4b6636bc] {
  border-color: #e0e4f0;
  border-style: solid;
  border-width: 1px 0 0;
  margin: 16px -16px;
}
.VideoCallSettings_Close-Button[data-v-4b6636bc] {
  position: absolute;
  top: 16px;
  right: 16px;
}
/*! CSS Used from: Embedded */
.HairCheck_Actions[data-v-0d7b3746] {
  --knpf-group-spacing: 8px;
  display: flex;
  position: relative;
  justify-content: center;
}

.dino-color {
  background-color: #15d2e54f !important;
  color: #0a6e8f !important;
}
</style>
